import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Libraries
import { Form, InputGroup } from "react-bootstrap";
import moment from "moment";


export default function EditOrderItemsTable({ orderItems, setOrderItems, supplier, customer, dateOrdered }) {
    const navigate = useNavigate()


    const [products, setProducts] = useState([]);

   
    const { user } = useAuthContext();


    const handleInputChange = async (index, field, value) => {
        if (field == "productCode") {
            // find the product that was selected
            var selectedProduct = products.find((product) => product.code == value);

            var costPrice = 0;
            var salePrice = 0;
            var haulageRate = 0;
            var customPricing;

            const orderDate = new Date(dateOrdered);

            // get the date, and see if we're on summer prices or winter prices
            // May to September - (javascript dates are 0 based)
            if (orderDate >= new Date(new Date().getFullYear(), 4, 1) && orderDate <= new Date(new Date().getFullYear(), 8, 30)) {
                costPrice = selectedProduct.costPriceSummer;
                salePrice = selectedProduct.salePriceSummer;
                haulageRate = selectedProduct.haulageRateSummer;
            } else {
                costPrice = selectedProduct.costPriceWinter;
                salePrice = selectedProduct.salePriceWinter;
                haulageRate = selectedProduct.haulageRateWinter;
            }

            // Now look up the product and see if this customer has a custom price contract for this product
            // if so, use that price instead of the default price
            const res = await axios.get(
                `https://${process.env.REACT_APP_IP}/api/products/${selectedProduct.id}/pricingcontracts`, {
                headers: { Authorization: `bearer ${user.token}` }
            })

            if (res.status === 200 && res.data) {

                // search through the contracts and see if the currently selected customer has a contract for this product
                const contract = res.data.find((contract) => contract.customer.id == customer);
                console.log("contract:", contract);
                if (contract != null) {
                    console.log("contract found for this customer and product");


                    // Override defaults if contract exists

                    if (orderDate >= new Date(new Date().getFullYear(), 4, 1) && orderDate <= new Date(new Date().getFullYear(), 8, 30)) {
                        costPrice = contract.costPriceSummer;
                        salePrice = contract.salePriceSummer;
                        haulageRate = contract.haulageRateSummer;
                        customPricing = contract;
                    } else {
                        costPrice = contract.costPriceWinter;
                        salePrice = contract.salePriceWinter;
                        haulageRate = contract.haulageRateWinter;
                        customPricing = contract;
                    }
                }
            };

            const updatedItems = orderItems.map((item, i) =>
                i === index ? {
                    ...item,
                    ["productCode"]: value,
                    ["productName"]: selectedProduct.name,
                    ["haulageRate"]: haulageRate,
                    ["costPrice"]: costPrice,
                    ["agentCostPrice"]: costPrice,
                    ["salePrice"]: salePrice,
                    ["customPricing"]: customPricing
                } : item
            );
            setOrderItems("orderItems", updatedItems);
        }
        else {

            const updatedItems = orderItems.map((item, i) =>
                i === index ? {
                    ...item,
                    [field]: value,
                } : item
            );
            setOrderItems("orderItems", updatedItems);
        }
    };

    const handleAddRow = () => {
        setOrderItems("orderItems", [...orderItems, { productCode: "0", deleted: false }]);
    }

    // Supplier Changed - Look up products for that supplier
    useEffect(() => {
        // Load products
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/products/?supplierId=${supplier}`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                if (res.status === 200) {
                    setProducts(res.data.data);
                }
            })
    }, [supplier])



  
    

    return (
        <div style={{marginBottom: 40}}>
            <table style={{width:"100%", marginBottom: 10}}>
                <thead>
                    <tr>
                        <th>Product</th>
                        <th style={{ width: 100 }}>Qty<br />Ordered</th>
                        <th style={{ width: 100 }}>Qty<br />Del.</th>
                        <th style={{ width: 150 }}>Haulage Rate</th>
                        <th style={{ width: 150 }}>AFS<br/> Cost Price</th>
                        <th style={{ width: 150 }}>Agent<br/> Cost Price</th>
                        <th style={{ width: 150 }}>Sale Price</th>
                        <th style={{ width: 50 }}>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    {orderItems && orderItems.map((item, index) => (
                        <>
                        <tr style={{display: item.deleted ? "none": ""}} key="index">
                            {/* Product Code / Item Description */}
                            <td>
                                <div className="select">
                                    <Form.Select
                                        onChange={e => handleInputChange(index, 'productCode', e.target.value)}
                                        value={item.productCode}
                                    >
                                        <option value="0" disabled>Please Select...</option>
                                        {products && (products.map((product) => {
                                            return <option key={product.id} value={product.code}>{product.name} {product.code && ('(' + product.code + ')')}</option>
                                        }))}
                                    </Form.Select>
                                </div>
                            </td>
                            {/* Quantity Ordered */}
                            <td>
                                <Form.Control
                                    type="text"
                                    value={item.quantityOrdered}
                                    onChange={e => handleInputChange(index, 'quantityOrdered', e.target.value)}
                                />
                            </td>
                            {/* Quantity Delivered */}
                            <td>
                                <Form.Control
                                    type="text"
                                    value={item.quantityDelivered}
                                    onChange={e => handleInputChange(index, 'quantityDelivered', e.target.value)}
                                />
                            </td>
                            {/* Haulage Rate */}
                            <td>
                                <InputGroup>
                                    <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                    <Form.Control
                                        type="text"
                                        value={item.haulageRate}
                                        onChange={e => handleInputChange(index, 'haulageRate', e.target.value)}
                                    />
                                </InputGroup>
                            </td>
                            {/* Cost Price */}
                            <td>
                                <InputGroup>
                                    <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                    <Form.Control
                                        type="text"
                                        value={item.costPrice}
                                        onChange={e => handleInputChange(index, 'costPrice', e.target.value)}
                                    />
                                </InputGroup>
                            </td>
                            {/* Agent Cost Price */}
                            <td>
                                <InputGroup>
                                    <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                    <Form.Control
                                        type="text"
                                        value={item.agentCostPrice}
                                        onChange={e => handleInputChange(index, 'agentCostPrice', e.target.value)}
                                    />
                                </InputGroup>
                            </td>
                            {/* Sale Price */}
                            <td>
                                <InputGroup>
                                    <InputGroup.Text>&pound;</InputGroup.Text> {/* Prefix */}
                                    <Form.Control
                                        type="text"
                                        value={item.salePrice}
                                        onChange={e => handleInputChange(index, 'salePrice', e.target.value)}
                                    />
                                </InputGroup>
                            </td>
                            
                            <td><button type="button" className="btn btn-other" onClick={() => { handleInputChange(index, 'deleted', true) }}>X</button></td>
                            </tr>

                            {item.customPricing && (
                                <tr>
                                    <td colspan="7">
                                        <span>Pricing Contract: {moment(item.customPricing.startDate).format('DD/MM/YYYY')} - {moment(item.customPricing.endDate).format('DD/MM/YYYY')} | {item.customPricing.tonnageAllowed} tonnes allowed, {item.customPricing.tonnageAllowed - item.customPricing.tonnageUsed} remaining</span>
                                    </td>

                                </tr>
                            
                            )}
                        </>

                    ))}
                </tbody>
            </table>

            <button type="button" className="btn btn-primary" onClick={handleAddRow}>Add Item</button>

            
        </div>
    )
}
